import React from 'react';
import { Header } from 'semantic-ui-react';

const SectionHeaderLayout = ({ myhr, title, headerclass, 
  align, children }) => {
  return (
    <React.Fragment>

      { myhr ? <div className="small__hr"></div> : null }

      <Header as="h1" textAlign={align} className={headerclass}> { title } </Header>

        { children }

    </React.Fragment>
  )
}

SectionHeaderLayout.defaultProps = {
  align: 'left',
  headerclass: '',
};

export default SectionHeaderLayout;